var numKeys = [
    {
        index: 0,
        keyCode: 'ONE',
        altKeyCode: 'NUMPAD_ONE',
        display: '1'
    },
    {
        index: 1,
        keyCode: 'TWO',
        altKeyCode: 'NUMPAD_TWO',
        display: '2'
    },
    {
        index: 2,
        keyCode: 'THREE',
        altKeyCode: 'NUMPAD_THREE',
        display: '3'
    },
    {
        index: 3,
        keyCode: 'FOUR',
        altKeyCode: 'NUMPAD_FOUR',
        display: '4'
    },
    {
        index: 4,
        keyCode: 'FIVE',
        altKeyCode: 'NUMPAD_FIVE',
        display: '5'
    },
    {
        index: 5,
        keyCode: 'SIX',
        altKeyCode: 'NUMPAD_SIX',
        display: '6'
    },
    {
        index: 6,
        keyCode: 'SEVEN',
        altKeyCode: 'NUMPAD_SEVEN',
        display: '7'
    },
    {
        index: 7,
        keyCode: 'EIGHT',
        altKeyCode: 'NUMPAD_EIGHT',
        display: '8'
    },
    {
        index: 8,
        keyCode: 'NINE',
        altKeyCode: 'NUMPAD_NINE',
        display: '9'
    },
    {
        index: 9,
        keyCode: 'ZERO',
        altKeyCode: 'NUMPAD_ZERO',
        display: '0'
    },
    {
        index: 10,
        keyCode: 'MINUS',
        altKeyCode: 'NUMPAD_MINUS',
        display: '- '
    },
];

export { numKeys };



// WEBPACK FOOTER //
// ./src/constants/KeyboardNumKeys.ts